import React from 'react'
import { Link } from 'react-router-dom';

function Nav(){
    return(
        <div>
            <div className="header-nav main-nav-one">
                <nav>
                    <ul className="parent-nav">
                        <li>
                            <Link  className="nav-link" to="/">
                                <span className="rolling-text">HOME</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="nav-link" to="/about">
                                <span className="rolling-text"><div className="block"><span className="letter">A</span><span className="letter">B</span><span className="letter">O</span><span className="letter">U</span><span className="letter">T</span></div><div className="block"><span className="letter">A</span><span className="letter">B</span><span className="letter">O</span><span className="letter">U</span><span className="letter">T</span></div></span>
                            </Link>
                        </li>
                        <li>
                            <Link className="nav-link" to="/Service">
                                <span className="rolling-text">SERVICE</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="nav-link" to="/Project">
                                <span className="rolling-text">PORTFOLIO</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="nav-link" to="/Blog">
                                <span className="rolling-text">BLOG</span>
                            </Link>
                        </li>  
                        <li>
                            <Link className="nav-link" to="/Contact">
                                <span className="rolling-text">CONTACT</span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}


export default Nav